import useDocNav from './DocNavHooks';
import './style.scss';

const DocNav: React.FC = () => {
    const { navData } = useDocNav();
    const { title, list } = navData;
    console.log('navData:', navData);

    return (
        <div className="paddle-api-nav">
            <div className="paddle-api-nav-title">{title}</div>
            <div className="paddle-api-nav-content">
                {list.map((item, index) => (
                    <div className="content-step" key={item.title}>
                        <div className="content-step-item-title">
                            <span className="content-step-item-title-order">{index + 1}</span>
                            {item.title}
                        </div>
                        <div className="content-step-item-content-wrapper">
                            <div className="content-step-item-desc">{item.desc}</div>
                            {item.stepList.map(element => (
                                <a href={element.link}>
                                    <div className="content-step-item-list" key={element.title}>
                                        <img
                                            className="content-step-item-list-icon"
                                            src={element.icon}
                                            alt={element.title}
                                        />
                                        <div className="content-step-item-list-title">
                                            {element.title}
                                            <span className="content-step-item-list-title-arrow" />
                                        </div>
                                        <div className="content-step-item-list-desc">{element.desc}</div>
                                    </div>
                                </a>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DocNav;
